import { Navigate, useParams } from "react-router";

import { findGuideArticle } from "./articles";

export function GuideRoute() {
  const { slug } = useParams<{ slug: string }>();
  const article = findGuideArticle(slug);
  if (!article) {
    return <Navigate to="/help" replace />;
  }
  const Component = article.component;
  return <Component />;
}
